/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let cadidateInfoWithQBankApiUrl = root.cadidateInfoWithQBankApiUrl.link;

export default {
  state: {
},
  mutations: {
  },
  actions: {
    // get Cadidate Info With Q Bank Info By id Action
    getCadidateInfoWithQBankInfoByIdAction(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(cadidateInfoWithQBankApiUrl + payload.id + '/').then(res => {
              resolve(res);
            }).catch(err => {
              reject(err);
            })
        })
    },
  },
  getters: {
  }
}